/* eslint-disable @next/next/no-img-element */
import { appSynonymGlobal } from '@/globals/appSynonym.global';
import { icons } from '@/globals/platformIcons';
import { IPlatform, THit } from '@/types';
import Image from 'next/image';
import Link from 'next/link';
import { Rating } from 'react-simple-star-rating';
import defaultImage from '../../../public/assets/image-placeholder.png';
import { Pagination } from '../pagination/pagination.comp';
import { LocalSearchBox } from '../searchBox/searchBox.comp';
import { Section } from '../section/section.comp';
import { StyledDiv } from './appList.styles';

export const AppList = ({
	activePlatform,
	categories = [],
	platforms = [],
	initialQuery = null,
	hits = [],
	page = 1,
	totalPages = 0,
	onPageChange,
}: {
	activePlatform?: IPlatform;
	categories?: any[];
	platforms?: IPlatform[];
	initialQuery?: string | null;
	hits?: THit[];
	page?: number;
	totalPages?: number;
	onPageChange?: (page: number) => void;
}) => {
	return (
		<Section style={{ paddingTop: 0 }}>
			<StyledDiv>
				<div className="discover-card">
					<p className="discover-title">Discover More</p>
					<LocalSearchBox
						searchAsYouType={true}
						enableAutoComplete={false}
						platform={activePlatform as any}
						autoFocus={false}
						initialQuery={initialQuery}
					/>
					{activePlatform && categories.length > 0 && (
						<>
							<p className="discover-title">
								Popular Categories{' '}
								{activePlatform.displayName
									? 'for ' + activePlatform.displayName
									: ''}
							</p>
							{categories.length > 0 &&
								categories.map((c) => (
									<Link
										key={c.slug}
										href={`/${
											activePlatform.displayName ? activePlatform.name : ''
										}/category/${c.slug}`}
									>
										{c.displayName}
									</Link>
								))}
						</>
					)}
					{platforms.length > 0 && (
						<>
							<p className="discover-title">Discover More Platforms</p>
							{platforms.map((p) => (
								<Link key={p.name} href={`/${p.name}`}>
									{p.appSynonym}s for {p.displayName}
								</Link>
							))}
						</>
					)}
				</div>
				<div className="apps-container">
					{hits.map((hit) => (
						<App key={hit._id} hit={hit} />
					))}
					{totalPages > 1 && onPageChange && (
						<Pagination
							pages={totalPages}
							currentPage={page}
							paginate={(p) => {
								if (p >= 1 && p <= totalPages && p !== page) {
									onPageChange(p);
								}
							}}
						/>
					)}
				</div>
			</StyledDiv>
		</Section>
	);
};

const App = ({ hit }: { hit: THit }) => {
	return (
		<Link
			key={hit._id}
			className="app"
			href={`/${hit.platform}/${
				(appSynonymGlobal as any)[hit.platform] || 'app'
			}/${hit.slug}`}
		>
			<div className="details">
				<div className="logo-wrapper">
					<Image
						width={100}
						height={100}
						src={hit.icon || defaultImage}
						alt={hit.name}
					/>
					<Image
						className="platform"
						src={(icons as any)[hit.platform]}
						alt={hit.name}
					/>
				</div>
				<div className="content">
					<h3>{(hit.name || '').replace(/\&#x2011;/g, '- ')}</h3>
					<p className="desc">{hit.teaser}</p>
					<div className="tags">
						{(hit.tags || []).slice(0, 4).map((t: string) => (
							<div key={t} className="tag">
								{t}
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="rating-wrapper">
				<Rating
					size={22}
					readonly={true}
					className="rating"
					fillColor={'#FFC657'}
					emptyColor={'#4D5265'}
					allowFraction
					initialValue={Math.round(hit.rating)}
				/>
				<p className="reviews">
					{hit.numberOfReviews ? hit.numberOfReviews.toLocaleString() : 'No'}{' '}
					reviews
				</p>
			</div>
		</Link>
	);
};
